import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { DarkModeProvider } from './context/DarkModeContext';
import { AuthProvider } from './context/AuthContext';
import { BookmarksProvider } from './context/BookmarksContext';
import Header from './components/Header';
import HomePage from './pages/HomePage';
import SearchPage from './pages/SearchPage';
import CategoriesPage from './pages/CategoriesPage';
import LibraryPage from './pages/LibraryPage';
import './styles.css';

function App() {
  return (
    <DarkModeProvider>
      <AuthProvider>
        <BookmarksProvider>
          <Router>
            <div className="App">
              <Header />
              <main>
                <Routes>
                  <Route path="/" element={<HomePage />} />
                  <Route path="/search" element={<SearchPage />} />
                  <Route path="/categories" element={<CategoriesPage />} />
                  <Route path="/categories/:categoryId" element={<CategoriesPage />} />
                  <Route path="/library" element={<LibraryPage />} />
                </Routes>
              </main>
            </div>
          </Router>
        </BookmarksProvider>
      </AuthProvider>
    </DarkModeProvider>
  );
}

export default App;
